<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 管理模式切换 -->
        <el-tab-pane>
          <span slot="label">{{ $t("logs.mode_switch1") }}</span>
          <div class="lie">
            <table>
              <tbody v-loading="loading">
                <tr>
                  <!-- 模式 -->

                  <td>{{ $t("logs.mode_switch2") }}:</td>
                  <td
                    style="display:flex; flex-direction:row;align-items:center;padding:10px 20px"
                  >
                    <span style="margin-right:20px">{{
                      this.mode_switch_show1
                    }}</span>
                    <el-alert
                      :title="this.mode_switch_show2"
                      type="warning"
                      show-icon
                      :closable="false"
                      v-show="this.mode_request!=0"
                    >
                    </el-alert>
                  </td>
                </tr>

                <tr v-show="this.mode_request == 1">
                  <!-- 密码 -->

                  <td>{{ $t("logs.mode_switch3") }}:</td>
                  <td
                    style="display:flex; flex-direction:row;align-items:center;"
                  >
                    <el-input
                      v-model="manager_pass"
                      placeholder=""
                      show-password
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("logs.group_sending1") }}:</td>
                  <td
                    style="padding-right:20px;padding:10px 20px;flex:1;color: #E6A23C;"
                  >
                    {{ this.mode_switch_show3 }}
                  </td>
                </tr>
                <tr v-if="this.mode_request == 1">
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button type="primary" @click="save_greylist()" :disabled="$root.jurisdiction.only_query==0">{{
                      this.mode_switch_show4
                    }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      mode_request: "",
      mode_type: "",
      manager_pass: "",
      loading: false,
      mode_switch_show1: "",
      mode_switch_show2: "",
      mode_switch_show3: "",
      mode_switch_show4: "",
      ret_img: "",
      office_att_check: "",
      office_att_scan_max_msgsize: "",
      office_att_scan_max_cn: "",
      office_att_oneatt_max_size: "",
      office_att_scan_num: "",
      office_att_scan_timeout: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      radio: [],
      data_loadok: "",
    };
  },
  mounted() {
    this.getFileList1();
  },
  methods: {
    save_greylist() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let str = this.$qs.stringify({
        __mode: "save_mode_switch_confirm",
        sid: sid,

        manager_pass: this.manager_pass,
      });
      this.$axios.post("/api/adm/cgi/admin.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu_edit = false;

          this.getFileList1();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 过滤单元加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "mode_switch_confirm",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;

            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.mode_switch_show1 = res.data.ret.show_mode;
            this.mode_switch_show2 = res.data.ret.confirm_hint1;
            this.mode_switch_show3 = res.data.ret.confirm_hint2;
            this.mode_switch_show4 = res.data.ret.save_button;
            // this.mode_type = res.data.ret.mode_type;
            this.mode_request = res.data.ret.mode_switch_request;
          }
        });
    },
    // 显示
    tan: function() {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
  padding-left: 14px;
}
</style>
